import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export function useQConfigGeneratorListSearchParams() {
  const [{ page, pageSize, field, sortOrder, sortBy }, setQueryParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    field: parseAsString.withDefault('createdAt'),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString,
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setQueryParams({ sortOrder, page: 0, sortBy });
  };

  return {
    page,
    pageSize,
    field,
    sortOrder,
    sortBy,
    changePageNumber,
    changePageSize,
    changeSorting,
  };
}
